import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoadingService } from '@core/service/loading.service';



@Component({
  standalone: true,
  selector: 'tmw-loading-spinner',
  template: `
  @if (isLoading()) {
    <div id="elmLoader">
      <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }
  `,
  imports: [CommonModule]
})
export class LoadSpinnerComponent {

  constructor(private readonly loadingService: LoadingService) {}
  isLoading = toSignal(this.loadingService.loadingSub, { initialValue: false });
}
